// extracted by mini-css-extract-plugin
export default {"melodyVideo":"sM-z","isFullWidth":"tM-z","landingPageVideo":"uM-z","play":"vM-z","iframeVideo":"wM-z","playHidden":"xM-z","fullwidth":"yM-z"};